import { ProgramTaskAction } from '@vestahealthcare/common/models';

export class MemberCCMTaskAction extends ProgramTaskAction {}

export default ProgramTaskAction;
